import { Component, OnInit } from '@angular/core';
import { SmarshToasterService } from './smarsh-toaster.service';
import { cilAudio } from '@coreui/icons';
export interface SmarshToasterData {
  text: {
    title: string;
    message: string;
  };
  visible: boolean;
  percentage: number;
}

@Component({
  selector: 'smarsh-toaster',
  templateUrl: 'smarsh-toast.component.html'
})
export class SmarshToastComponent implements OnInit {
  data: SmarshToasterData = {
    text: undefined,
    percentage: 0,
    visible: false
  };
  position = 'top-end';
  protected readonly cilAudio = cilAudio;

  constructor(private smarshToasterService: SmarshToasterService) {}

  ngOnInit() {
    const context = this;
    this.smarshToasterService.onChange().subscribe({
      next(value: SmarshToasterData) {
        context.data = value;
      }
    });
  }

  onVisibleChange($event: boolean) {
    this.data.visible = $event;
    if (!this.data.visible) {
      this.data.text = undefined;
      this.data.percentage = 0;
    }
  }
}
